import React, {Component} from 'react';
import Post from './post/list';
import {IComponent} from '../core/models/component';

interface IProps {
     data : {
          posts: [IComponent];
          id: string;
          domElement: any;
     }
}

class List extends Component < IProps > {

     componentDidMount() {          
          const node = document.getElementById('list-component-' + this.props.data.id);
          this
               .props
               .data
               .domElement
               .appendChild(node);
     }

     public render() {
          const posts = this.props.data.posts || [];
          return (
               <div
                    className="list-component-holder"
                    id={'list-component-' + this.props.data.id}>
                    {posts.map((post : any, key : number) => <Post data={post} key={key}/>)}
               </div>
          );
     }
}

export default List;